<template>
  <div :class="dateFlags"
       class="date"
  >
    <i v-if="dateFlags.pastDeeadline"
       class="fas fa-clock"
       v-help.mouse="`Již po deadline - zadaném datu`"
    ></i>
    {{ formatedValue }}
    <div v-if="isDeadline && timeRemaining.asDays() <= 30 && timeRemaining.asDays() >= 0"
         class="progress"
    >
      <div class="progress-bar"
           :class="progressBarClass"
           :style="{'width': `${100 - remainingPercentage}%`}"
      >
        <span>{{ humanizedRemaining }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { DATE_FORMAT, InvalidDateString } from 'CORE/utils/date'

export default {
    name: 'DateTimeDetail',
    props: {
        value: { default: null, type: Object },
        id: { default: _ => '', type: String },
        tooltip: { default: _ => null, type: String },
    },
    computed: {
        propertyType() {
            return this.$store.getters.propertyTypeByKey(this.id) || {}
        },
        dateFlags() {
            const flags = { pastDeeadline: false }
            const isDeadline = _.get(this.propertyType, 'settings.systags.deadline', false)
            if (isDeadline) {
                try {
                    if (moment(this.value.value.value, 'X').isBefore()) {
                        flags.pastDeeadline = true
                    }
                } catch (e) {
                    if (!(e instanceof InvalidDateString)) {
                        console.error(e)
                    }
                }
            }
            return flags
        },
        isDeadline() {
            return _.get(this.propertyType, 'settings.systags.deadline', false)
        },
        timeRemaining() {
            const now = moment(new Date())
            const end = moment(this.value.value.value, 'X')
            return moment.duration(end.diff(now))
        },
        remainingPercentage() {
            const daysRemaining = this.timeRemaining.asDays()
            if (daysRemaining >= 30) return 100
            if (daysRemaining <= 0) return 0
            return (daysRemaining / 30) * 100
        },
        humanizedRemaining() {
            try {
                if (this.timeRemaining.asDays() > 0) {
                    return `za ${this.timeRemaining.humanize()}`
                } else {
                    return `před ${this.timeRemaining.humanize()}`
                }
            } catch (e) {
                console.error(e)
                return ''
            }
        },
        progressBarClass() {
            const daysRemaining = Math.floor(this.timeRemaining.asDays())
            return {
                'last-day': daysRemaining <= 1,
                'last-week': !!(daysRemaining > 1 && daysRemaining <= 7),
            }
        },
        formatedValue() {
            try {
                return moment(this.value.value.value, 'X').format(DATE_FORMAT)
            } catch (e) {
                if (!(e instanceof InvalidDateString)) {
                    console.error(e)
                }
                return undefined
            }
        },
    },
}
</script>

<style>
.pastDeeadline {
    color: OrangeRed;
}
.date {
    white-space: nowrap
}
.last-day {
    background-color: var(--danger);
}
.last-week {
    background-color: var(--warning);
}
</style>
